import { render, staticRenderFns } from "./DashboardFunnel.vue?vue&type=template&id=42ba070b&scoped=true&"
import script from "./DashboardFunnel.vue?vue&type=script&lang=js&"
export * from "./DashboardFunnel.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFunnel.vue?vue&type=style&index=0&id=42ba070b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ba070b",
  null
  
)

export default component.exports